import React, { useState, useEffect, useRef } from 'react';
import Globals from '../Globals';
import { HashLink } from 'react-router-hash-link';
import DepartureCalculator from './DepartureCalcul';

const API = Globals.API;

function Sports() {
 const [showSuccess, setShowSuccess] = useState(false);
 const [events, setEvents] = useState([]);
 const [loading, setLoading] = useState(true);
 const [selectedEvent, setSelectedEvent] = useState(null);
 const [showModal, setShowModal] = useState(false);
 const [selectedSport, setSelectedSport] = useState('all');
 const [sportTypes, setSportTypes] = useState([]);
 const [isVideoVisible, setIsVideoVisible] = useState(false);
 const videoRef = useRef(null);

 useEffect(() => {
 const observer = new IntersectionObserver(
 ([entry]) => { if (entry.isIntersecting) setIsVideoVisible(true); },
 { threshold: 0.2 }
 );
 const currentRef = videoRef.current;
 if (currentRef) observer.observe(currentRef);
 return () => { if (currentRef) observer.unobserve(currentRef); };
 }, []);

 useEffect(() => {
 const urlParams = new URLSearchParams(window.location.search);
 if (urlParams.get('success') === 'true') {
 setShowSuccess(true);
 setTimeout(() => {
 window.history.replaceState({}, '', window.location.pathname);
 setShowSuccess(false);
 }, 5000);
 }
 fetchEvents();
 }, []);

 const fetchEvents = async () => {
 try {
 const response = await fetch(`${API}/events`);
 const result = await response.json();
 if (result.success) {
 const sportEvents = result.data.filter(e => e.category === 'sport' && e.isActive);
 setEvents(sportEvents);
 const uniqueSports = [...new Set(sportEvents.map(e => e.sportType || e.destination))];
 setSportTypes(uniqueSports);
 }
 } catch (error) {
 console.error('Error fetching events:', error);
 } finally {
 setLoading(false);
 }
 };

 const openModal = (event) => { setSelectedEvent(event); setShowModal(true); };
 const closeModal = () => { setShowModal(false); setSelectedEvent(null); };

 const filteredEvents = selectedSport === 'all'
 ? events
 : events.filter(e => (e.sportType || e.destination) === selectedSport);

 return (
 <div>

 {/* ══ MODAL ══ */}
 {showModal && selectedEvent && (
 <div
 className="modal fade show"
 style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(5px)' }}
 onClick={closeModal}
 >
 <div className="modal-dialog modal-lg modal-dialog-scrollable" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px' }}>
 <div className="modal-content" style={{ border: 'none', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>

 <div className="modal-header" style={{ background: 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)', color: 'white', padding: '1.5rem', border: 'none' }}>
 <h5 className="modal-title fw-bold">{selectedEvent.title}</h5>
 <button type="button" className="btn-close btn-close-white" onClick={closeModal} style={{ opacity: 1 }}></button>
 </div>

 <div className="modal-body" style={{ padding: '2rem' }}>
 <div className="position-relative mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 <img src={selectedEvent.image} alt={selectedEvent.title} className="img-fluid w-100" style={{ maxHeight: '400px', objectFit: 'cover' }} />
 <div className="position-absolute bottom-0 start-0 w-100 p-3" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)' }}>
 <h6 className="text-white mb-0"><i className="fa fa-dumbbell me-2"></i>{selectedEvent.sportType || selectedEvent.destination}</h6>
 </div>
 </div>

 {selectedEvent.departureDates?.map((departure, index) => {
 const pricing = departure.pricing?.b2c || {};
 const isComplet = !departure.isAvailable || departure.availableSeats === 0;
 return (
 <div key={index} className="mb-4 p-4" style={{ background: 'white', borderRadius: '15px', border: '1px solid #e9ecef' }}>
 <div className="d-flex justify-content-between align-items-center mb-3">
 <div>
 <strong style={{ color: '#2B4C7E' }}><i className="fa fa-plane-departure me-2"></i>Départ: {new Date(departure.departureDate).toLocaleDateString('fr-FR')}</strong><br />
 <strong style={{ color: '#2B4C7E' }}><i className="fa fa-plane-arrival me-2"></i>Retour: {new Date(departure.returnDate).toLocaleDateString('fr-FR')}</strong>
 </div>
 <span className={`badge ${isComplet ? 'bg-danger' : 'bg-success'}`}>
 {isComplet ? 'Complet' : `${departure.availableSeats} places disponibles`}
 </span>
 </div>
 <div className="row g-2 mb-3">
 {pricing.price != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Prix standard :</strong> {pricing.price} TND</div></div>}
 {pricing.tarifdemidouble != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Demi-double :</strong> {pricing.tarifdemidouble} TND</div></div>}
 {pricing.spplementsingle != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Supplément single :</strong> {pricing.spplementsingle} TND</div></div>}
 {pricing.bebe != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Bébé :</strong> {pricing.bebe} TND</div></div>}
 {pricing.enf2_6 != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Enfant 2–6 ans :</strong> {pricing.enf2_6} TND</div></div>}
 {pricing.enf6_12 != null && <div className="col-md-6"><div className="p-2 bg-light rounded"><strong>Enfant 6–12 ans :</strong> {pricing.enf6_12} TND</div></div>}
 </div>
 <DepartureCalculator departure={departure} />
 </div>
 );
 })}

 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}><i className="fa fa-info-circle me-2"></i>Description</h5>
 <p className="text-muted" style={{ lineHeight: '1.8' }}>{selectedEvent.description}</p>
 </div>

 {selectedEvent.program && (
 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}><i className="fa fa-list-ul me-2"></i>Programme</h5>
 <div className="p-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '15px', borderLeft: '4px solid #2B4C7E' }}>
 {selectedEvent.program.split('\n').map((line, i) => (
 <p key={i} className="mb-2" style={{ lineHeight: '1.8' }}><i className="fa fa-check text-success me-2"></i>{line}</p>
 ))}
 </div>
 </div>
 )}

 {selectedEvent.voldetails && (
 <div className="mb-4">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}><i className="fa fa-plane-departure me-2"></i>Détails du Vol</h5>
 <div className="p-3" style={{ background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', borderRadius: '15px' }}>
 <p className="mb-0" style={{ lineHeight: '1.8' }}>{selectedEvent.voldetails}</p>
 </div>
 </div>
 )}

 <div className="row g-4 mb-4">
 <div className="col-md-6">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}><i className="fa fa-check-circle me-2"></i>Services Inclus</h5>
 <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 {selectedEvent.includedServices.map((s, i) => (
 <li key={i} className="list-group-item border-0 mb-2" style={{ background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)', borderRadius: '10px' }}>
 <i className="fa fa-check-circle text-success me-2"></i>{s}
 </li>
 ))}
 </ul>
 </div>
 <div className="col-md-6">
 <h5 className="fw-bold mb-3" style={{ color: '#2B4C7E' }}><i className="fa fa-times-circle me-2"></i>Services Non Inclus</h5>
 <ul className="list-group" style={{ borderRadius: '15px', overflow: 'hidden' }}>
 {selectedEvent.excludedServices.map((s, i) => (
 <li key={i} className="list-group-item border-0 mb-2" style={{ background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)', borderRadius: '10px' }}>
 <i className="fa fa-times-circle text-danger me-2"></i>{s}
 </li>
 ))}
 </ul>
 </div>
 </div>
 </div>

 <div className="modal-footer" style={{ borderTop: '2px solid #e9ecef', padding: '1.5rem 2rem' }}>
 <button type="button" className="btn btn-light px-4" onClick={closeModal} style={{ borderRadius: '10px' }}>Fermer</button>
 <HashLink
 to={selectedEvent?.isActive ? '/#res' : '#'}
 className={`btn px-4 ${selectedEvent?.isActive ? 'text-white' : 'text-muted'}`}
 style={{
 background: selectedEvent?.isActive ? 'linear-gradient(135deg, #2B4C7E 0%, #567ebb 100%)' : '#ced4da',
 borderRadius: '10px',
 boxShadow: selectedEvent?.isActive ? '0 4px 15px rgba(43,76,126,0.3)' : 'none',
 cursor: selectedEvent?.isActive ? 'pointer' : 'not-allowed',
 pointerEvents: selectedEvent?.isActive ? 'auto' : 'none',
 }}
 onClick={selectedEvent?.isActive ? closeModal : undefined}
 >
 <i className="fa fa-calendar-check me-2"></i>
 {selectedEvent?.isActive ? 'Réserver Maintenant' : 'Événement complet'}
 </HashLink>
 </div>

 </div>
 </div>
 </div>
 )}

 {/* ══ HERO ══ */}
 <div className="container-fluid position-relative py-0 mb-0 hero-header" style={{
 backgroundImage: 'url(https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1920&h=600&fit=crop)',
 backgroundSize: 'cover', backgroundPosition: 'center',
 overflow: 'hidden', minHeight: '200px'
 }}>
 <div className="position-absolute w-100 h-100 top-0 start-0" style={{ background: 'linear-gradient(135deg, rgba(160,161,163,0.85) 0%, rgba(42,59,84,0.85) 50%, rgba(4,36,75,0.85) 100%)' }}></div>
 <div className="position-absolute w-100 h-100 top-0 start-0" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)', pointerEvents: 'none' }}></div>
 <div className="container py-5 position-relative">
 <div className="row justify-content-center py-5">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white fw-bold mb-4 animated slideInDown" style={{ textShadow: '0 4px 20px rgba(0,0,0,0.5)', fontFamily: 'Inter, sans-serif' }}>
 Nos Événements Sportifs
 </h1>
 <p className="text-white fs-5 mb-4">Vivez l'émotion du sport en direct</p>
 </div>
 </div>
 </div>
 </div>

 {/* ══ EVENTS ══ */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
 <h1 className="mb-3 fw-bold" style={{ color: '#01225C', fontFamily: 'Inter, sans-serif' }}>
 Découvrez Nos Événements Sportifs
 </h1>
 <p className="fs-5" style={{ color: '#00338C' }}>Des moments inoubliables avec vos équipes préférées</p>
 </div>

 {/* Filter */}
 {!loading && events.length > 0 && (
 <div className="row mb-5">
 <div className="col-12">
 <div className="d-flex justify-content-center align-items-center p-4" style={{ background: '#EEF4FE', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
 <label htmlFor="sport-filter" className="me-3" style={{ color: '#00338C', fontWeight: 'bold', fontSize: '1.1rem' }}>
 <i className="fa fa-filter me-2"></i>Filtrer par destination:
 </label>
 <select
 id="sport-filter"
 className="form-select"
 value={selectedSport}
 onChange={e => setSelectedSport(e.target.value)}
 style={{ borderColor: '#CBDEFC', borderWidth: '2px', borderRadius: '10px', maxWidth: '300px', fontSize: '1rem', padding: '0.6rem 1rem' }}
 >
 <option value="all">Toutes les destinations ({events.length})</option>
 {sportTypes.map((sport, i) => (
 <option key={i} value={sport}>{sport} ({events.filter(e => (e.sportType || e.destination) === sport).length})</option>
 ))}
 </select>
 </div>
 </div>
 </div>
 )}

 {loading ? (
 <div className="text-center py-5">
 <div className="spinner-border" style={{ color: '#2B4C7E', width: '3rem', height: '3rem' }} role="status">
 <span className="visually-hidden">Chargement...</span>
 </div>
 <p className="mt-3 text-muted">Chargement des événements sportifs...</p>
 </div>
 ) : filteredEvents.length === 0 ? (
 <div className="text-center py-5">
 <i className="fa fa-search fa-3x mb-3" style={{ color: '#2B4C7E', opacity: 0.3 }}></i>
 <p className="text-muted fs-5">
 {selectedSport === 'all'
 ? 'Aucun événement sportif disponible pour le moment.'
 : `Aucun événement disponible pour ${selectedSport}.`}
 </p>
 </div>
 ) : (

 /* ══ CARTES ══ */
 <div className="row g-4 justify-content-center px-lg-4">
 {filteredEvents.map((event, index) => (
 <div key={event._id} className="col-lg-5 col-md-10 wow fadeInUp px-3" data-wow-delay={`${0.1 * (index + 1)}s`}>
 <div
 style={{
 position: 'relative',
 width: '100%',
 paddingBottom: '75%',
 borderRadius: '12px',
 overflow: 'hidden',
 boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
 cursor: 'pointer',
 transition: 'transform 0.3s ease, box-shadow 0.3s ease',
 }}
 onMouseEnter={e => {
 e.currentTarget.style.transform = 'scale(1.03)';
 e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.35)';
 }}
 onMouseLeave={e => {
 e.currentTarget.style.transform = 'scale(1)';
 e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.25)';
 }}
 >
 {/* Image plein format */}
 <img
 src={event.image}
 alt={event.title}
 style={{
 position: 'absolute',
 top: 0, left: 0,
 width: '100%',
 height: '100%',
 objectFit: 'cover',
 display: 'block',
 }}
 />

 {/* Badge destination — haut gauche jaune */}
 <div style={{
 position: 'absolute', top: '1rem', left: '1rem',
 display: 'flex', gap: '8px', zIndex: 3
 }}>
 <span style={{
 background: '#FFBC1E',
 color: '#fff',
 fontFamily: 'Inter, sans-serif',
 fontSize: '0.70rem',
 fontWeight: '700',
 letterSpacing: '0.1em',
 textTransform: 'uppercase',
 padding: '4px 12px',
 borderRadius: '3px',
 }}>
 {event.sportType || event.destination || 'Sport'}
 </span>
 {!event.isActive && (
 <span style={{
 background: 'rgba(220,53,69,0.95)',
 color: '#fff',
 fontFamily: 'Inter, sans-serif',
 fontSize: '0.70rem',
 fontWeight: '700',
 letterSpacing: '0.1em',
 textTransform: 'uppercase',
 padding: '4px 12px',
 borderRadius: '6px',
 }}>
 COMPLET
 </span>
 )}
 </div>

 {/* Gradient blue to transparent */}
 <div style={{
 position: 'absolute',
 bottom: 0, left: 0, right: 0,
 background: 'linear-gradient(to top, rgba(5, 25, 75, 1) 0%, rgba(10, 40, 110, 0.92) 35%, rgba(15, 50, 120, 0.55) 60%, transparent 100%)',
 padding: '1.8rem 1.6rem 1.4rem',
 zIndex: 2,
 borderBottomLeftRadius: '12px',
 borderBottomRightRadius: '12px',
 }}>
 <h3 style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: '1.25rem',
 fontWeight: '700',
 color: '#fff',
 marginBottom: '8px',
 marginTop: 0,
 lineHeight: '1.3',
 }}>
 {event.title}
 </h3>

 <p style={{
 fontFamily: 'Inter, sans-serif',
 fontSize: '0.87rem',
 color: 'rgba(255,255,255,0.88)',
 lineHeight: '1.6',
 marginBottom: '12px',
 }}>
 {event.description.length > 110
 ? `${event.description.substring(0, 110)}...`
 : event.description}
 </p>

 <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
 <button
 type="button"
 onClick={() => openModal(event)}
 style={{
 background: 'none',
 border: 'none',
 padding: 0,
 color: '#fff',
 fontFamily: 'Inter, sans-serif',
 fontSize: '0.80rem',
 fontWeight: '700',
 letterSpacing: '0.14em',
 textTransform: 'uppercase',
 cursor: 'pointer',
 transition: 'opacity 0.2s',
 }}
 onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
 onMouseLeave={e => e.currentTarget.style.opacity = '1'}
 >
 DISCOVER MORE →
 </button>
 </div>
 </div>

 </div>
 </div>
 ))}
 </div>

 )}
 </div>
 </div>

 </div>
 );
}

export default Sports;